/**
 * The Visual guide's version (Workspace v2 §15.7: "Store completion/dismissal
 * by adviser and guide version, not by client").
 *
 * Stored per adviser in `adviser_preferences` (migration 0049) as the version
 * they completed or dismissed, and the version at which they dismissed the
 * Clients first-use strip. Bump this ONLY when the guide changes enough that an
 * adviser who finished the old one is better off being offered the new one.
 *
 * Version 2 (2026-09-19): the six-scene panel became a chaptered guide, and
 * `visualGuideCompletedVersion` changed meaning with it — it recorded "reached
 * Done on scene six", and now records "finished the essentials path". An
 * adviser who completed v1 has not seen the new path, so the completion at v1
 * must not silently count as completion of this one; the first-use strip reads
 * exactly that key. The local per-adviser progress store is keyed by version
 * too, so six-scene progress can never resume into a chapter.
 */
export const VISUAL_GUIDE_VERSION = 2;
/** The bounds 0049's CHECK constraints enforce, kept beside the version they bound. */
export const GUIDE_VERSION_MIN = 1;
export const GUIDE_VERSION_MAX = 1000;
//# sourceMappingURL=visualGuide.js.map